module.exports = __webpack_public_path__ + "static/media/24.d0f669dd.png";